import Joi from "joi";

const StateMasterSchema = Joi.object({
  stateName: Joi.string().trim().required().messages({
    "string.empty": "State Name is required.",
  }),
  country: Joi.string().trim().required().messages({
    "string.empty": "Country is required.",
  }),
}).unknown(true);

export default StateMasterSchema;
